'use client';

import POIMapComponents from '@/components/POIMapComponents/POIMapComponents';
import TrailResultsMapComponents from '@/components/TrailResultsMapComponents/TrailResultsMapComponents';

export default function ExplorePOIMapComponentsSlot() {
  return (
    <>
      <TrailResultsMapComponents />
      <POIMapComponents poiLocation="explore map poi focused state" shouldNavigateToPOIUrl />
    </>
  );
}
